@if (dragDrop()) {
<div class="flex w-full h-40">
  @if (showPreview()) {
  <app-image-preview *ngIf="previewUrl$ | async as previewUrl " class="w-52 h-full rounded-xl mr-6"
    [url]="previewUrl"></app-image-preview>
  <div *ngIf="(previewUrl$ | async) === null || (previewUrl$ | async) === undefined"></div>
  }
  <div class="w-full h-full rounded-md border-dashed border-2 border-gray-light flex items-center justify-between"
    [class]="isDragHover() ? 'bg-white' : 'bg-gray-input'" (drop)="dropHandler($event)" (dragleave)="dragLeaveHandler()"
    (dragend)="dragLeaveHandler()" (dragover)="dragOverHandler($event)" (dragenter)="dragOverHandler($event)">
    <div></div>
    <div class="flex">
      <div class="w-[44px] h-[44px] rounded-full bg-gray-light flex items-center justify-center mr-4">
        <app-icon class="text-gray" name="heroArrowDownTray"></app-icon>
      </div>
      <div>
        <button type="button" class="text-blue cursor-pointer underline font-semibold" (click)="fileUpload.click()">Upload
          image</button>
        <p class="text-gray-400 text-[10px]/4">File size must not exceed 20Mb</p>
      </div>
    </div>
    <div></div>
  </div>
</div>

} @else {
<button type="button" class="text-blue cursor-pointer underline font-semibold" (click)="fileUpload.click()">Upload
  image</button>
<p class="text-gray-400 text-[10px]/4">File size must not exceed 20Mb</p>
}
<input type="file" [multiple]="isMultiple()" class="hidden" (change)="onFileSelected($event)" #fileUpload
  [accept]="requiredFileType()">
